<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-07-19 09:31:46
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2022-07-21 10:50:48
-->
<template>
  <div class="word use_clause p-t-120">
    <div class="word-title">{{$t('useClause.title')}}</div>
    <div class="">
      <div>
        <div v-for="(item, index) in $t('useClause.des')" :key="index">{{item}}</div>
      </div>
      <div class="word-main">
        <div class="word-main-list" v-for="(item,index) in $t('useClause.list')" :key="index">
          <div class="title"><span v-html="item.title"></span><i class="line center_left_right"></i></div>
          <div class="des" v-for="(list,i) in item.des" :key="i" v-html="list"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {}
  }
}
</script>
<style lang="less">

</style>
